import ICampanhaComercial from "../interfaces/ICampanhaComercial";
import api from "./api";
import { resources } from "./resources";

export interface ICampanhaComercialPagedResult {
    items: ICampanhaComercial[];
    rowCount: number;
}

class CampanhaComercialService {
    async getAllCampanhas(filters?: { ativo?: string; numeroCampanha?: string; nomeCampanha?: string; page?: number; pageSize?: number }) {
        const params = new URLSearchParams();
        if (filters?.ativo && filters.ativo !== "") {
            params.append("ativo", filters.ativo);
        }
        if (filters?.numeroCampanha && filters.numeroCampanha.trim() !== "") {
            params.append("numeroCampanha", filters.numeroCampanha.trim());
        }
        if (filters?.nomeCampanha && filters.nomeCampanha.trim() !== "") {
            params.append("nomeCampanha", filters.nomeCampanha.trim());
        }
        if (filters?.page !== undefined) {
            params.append("page", String(filters.page));
        }
        if (filters?.pageSize !== undefined) {
            params.append("pageSize", String(filters.pageSize));
        }
        const query = params.toString() ? `?${params.toString()}` : "";
        return await api.get<ICampanhaComercialPagedResult>(`${resources.campanhaComercial}/AllCampanhas${query}`);
    }
}

export default new CampanhaComercialService();
